import React from 'react';
import {Link} from 'react-router-dom';
import {StyleSheet, css} from 'aphrodite';

const SUPPORT_EMAIL = 'support@yabathoplatform.co.za';

export default function DeleteAccount() {
  return (
    <main className={css(styles.page)}>
      <section className={css(styles.hero)}>
        <div className={css(styles.logoMark)}>YB</div>
        <p className={css(styles.kicker)}>YaBatho Account Support</p>
        <h1 className={css(styles.title)}>Delete your YaBatho account</h1>
        <p className={css(styles.subtitle)}>
          You can request deletion of your YaBatho customer account and
          associated personal data by contacting our support team.
        </p>
      </section>

      <section className={css(styles.card)}>
        <h2>How to request deletion</h2>
        <p>
          Send an email to{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> with the
          subject line <strong>Delete my YaBatho account</strong>.
        </p>

        <div className={css(styles.infoGrid)}>
          <div>
            <h3>Include these details</h3>
            <ul>
              <li>Your full name</li>
              <li>Your registered email address</li>
              <li>Your registered phone number</li>
            </ul>
          </div>

          <div>
            <h3>What we delete</h3>
            <ul>
              <li>Your customer profile</li>
              <li>Your contact details</li>
              <li>Your saved delivery addresses</li>
              <li>Your app access data where deletion is permitted</li>
            </ul>
          </div>
        </div>

        <div className={css(styles.notice)}>
          <h3>Records we may keep</h3>
          <p>
            Some order, payment, transaction, tax, accounting, fraud
            prevention, security, and legal records may be retained where we
            are required or allowed to keep them.
          </p>
        </div>

        <p className={css(styles.timeline)}>
          Account deletion requests are reviewed and processed within 30 days.
        </p>

        <div className={css(styles.actions)}>
          <a className={css(styles.primaryButton)} href={`mailto:${SUPPORT_EMAIL}`}>
            Email support
          </a>
          <Link className={css(styles.secondaryButton)} to="/home">
            Go home
          </Link>
        </div>
      </section>
    </main>
  );
}

const styles = StyleSheet.create({
  page: {
    minHeight: '100vh',
    backgroundColor: '#FFFDF7',
    color: '#0F3D2E',
    fontFamily: 'Inter, Segoe UI, Arial, sans-serif',
    padding: '32px 18px 96px',
    boxSizing: 'border-box',
  },
  hero: {
    maxWidth: 920,
    margin: '0 auto 22px',
    backgroundColor: '#0F3D2E',
    color: '#ffffff',
    borderRadius: 28,
    padding: '34px',
    border: '1px solid rgba(201, 161, 74, 0.45)',
    boxShadow: '0 22px 50px rgba(15, 61, 46, 0.16)',
  },
  logoMark: {
    width: 58,
    height: 58,
    borderRadius: '50%',
    backgroundColor: '#F4EBD8',
    color: '#C9A14A',
    border: '2px solid #C9A14A',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 900,
    marginBottom: 18,
  },
  kicker: {
    margin: '0 0 8px',
    color: '#C9A14A',
    fontSize: 12,
    fontWeight: 900,
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
  title: {
    margin: 0,
    color: '#ffffff',
    fontSize: 42,
    lineHeight: 1.05,
    fontWeight: 900,
  },
  subtitle: {
    maxWidth: 720,
    margin: '14px 0 0',
    color: '#F4EBD8',
    fontSize: 16,
    lineHeight: 1.7,
  },
  card: {
    maxWidth: 920,
    margin: '0 auto',
    backgroundColor: '#ffffff',
    border: '1px solid #E6D8BE',
    borderRadius: 24,
    padding: 28,
    boxShadow: '0 12px 34px rgba(30, 30, 30, 0.06)',
    boxSizing: 'border-box',

    h2: {
      margin: '0 0 10px',
      fontSize: 26,
      color: '#0F3D2E',
    },

    p: {
      color: '#6E6254',
      lineHeight: 1.7,
    },

    a: {
      color: '#0F3D2E',
      fontWeight: 900,
    },
  },
  infoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: 16,
    marginTop: 18,

    div: {
      backgroundColor: '#FFFDF7',
      border: '1px solid #F1E7D2',
      borderRadius: 18,
      padding: 18,
    },

    h3: {
      margin: '0 0 10px',
      color: '#0F3D2E',
      fontSize: 17,
    },

    ul: {
      margin: 0,
      paddingLeft: 20,
      color: '#6E6254',
      lineHeight: 1.8,
    },
  },
  notice: {
    marginTop: 18,
    border: '1px solid #E6D8BE',
    borderRadius: 18,
    backgroundColor: '#F4EBD8',
    padding: 18,

    h3: {
      margin: '0 0 8px',
      color: '#0F3D2E',
    },

    p: {
      margin: 0,
    },
  },
  timeline: {
    fontWeight: 900,
  },
  actions: {
    display: 'flex',
    gap: 12,
    flexWrap: 'wrap',
    marginTop: 20,
  },
  primaryButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 48,
    padding: '0 20px',
    borderRadius: 16,
    backgroundColor: '#C9A14A',
    color: '#0F3D2E',
    textDecoration: 'none',
    fontWeight: 900,
  },
  secondaryButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 48,
    padding: '0 20px',
    borderRadius: 16,
    backgroundColor: '#ffffff',
    color: '#0F3D2E',
    border: '1px solid #E6D8BE',
    textDecoration: 'none',
    fontWeight: 900,
  },
});
